<template>
    <div :class="['r-card__meta-item', { 'r-card__meta-item--full' : fullWidth }]">
        <template v-if="documentURL">
            <span>{{ label }}: </span><a :href="documentURL" target="_blank" rel="noreferrer noopener">{{ documentURL }}</a>
        </template>

        <template v-else>
            <span>{{ label }}: </span>{{ val }}
        </template>
    </div>
</template>

<script>
import { toTitleCase } from '@/helpers'
import { DOC_URL } from '@/helpers/axios'

export default {
    props: {
        label: { type: String, required: true },
        value: { type: [String, Array], required: true },
        fullWidth: { type: Boolean, default: false },
        titleCase: { type: Boolean, default: false },
        docURL: { type: String }
    },

    computed: {
        val () {
            if (this.titleCase && typeof this.value === 'string') return toTitleCase(this.value)
            if (Array.isArray(this.value)) {
                return this.value.reduce((acc, val) => `${acc}, ${val}`)
            }
            return this.value
        },

        documentURL () {
            return this.docURL
                ? this.docURL.replace('C:/inetpub/wwwroot/edmentalhealthdev.acem.org.au/src/uploads/', DOC_URL)
                : null
        }
    },

}
</script>

